module.exports = __webpack_public_path__ + "static/media/1 Black.3aad40ee.svg";